import axios from "../redux/sagas/axios";
import { store } from "../redux/store";

// Currency symbols mapping
export const currencySymbols = {
  USD: "$",
  ZMW: "K",
  EUR: "€",
  GBP: "£",
  NGN: "₦",
  GHS: "₵",
  KES: "KSh",
  UGX: "USh",
  TZS: "TSh",
  ZAR: "R",
  BWP: "P",
  MWK: "MK",
};

// Get token from store
const getToken = () => {
  const state = store.getState();
  return state.userData.token;
};

// Get system currency from API
export const getSystemCurrency = async () => {
  try {
    const response = await axios.get("/currency/system-currency");
    return response.data.systemCurrency || "USD";
  } catch (error) {
    console.error("Error fetching system currency:", error);
    return "USD"; // fallback to USD
  }
};

// Convert USD balance to display currency
export const convertBalance = async (usdBalance) => {
  try {
    const systemCurrency = await getSystemCurrency();

    if (systemCurrency === "USD") {
      return { amount: usdBalance, currency: "USD" };
    }

    const response = await axios.post("/currency/convert", {
      amount: usdBalance,
      fromCurrency: "USD",
      toCurrency: systemCurrency,
    });

    return {
      amount: response.data.convertedAmount,
      currency: systemCurrency,
    };
  } catch (error) {
    console.error("Error converting balance:", error);
    return { amount: usdBalance, currency: "USD" }; // fallback
  }
};

// Display balance with currency symbol
export const displayBalance = async (userUsdBalance) => {
  try {
    const { amount, currency } = await convertBalance(userUsdBalance);
    const symbol = currencySymbols[currency] || "";
    return `${symbol}${amount.toFixed(2)} ${currency}`;
  } catch (error) {
    console.error("Error displaying balance:", error);
    return `$${userUsdBalance.toFixed(2)} USD`; // fallback
  }
};

// Format currency amount with symbol
export const formatCurrency = (amount, currency = "USD") => {
  const symbol = currencySymbols[currency] || "";
  return `${symbol}${parseFloat(amount).toFixed(2)} ${currency}`;
};

// Convert any amount between currencies
export const convertCurrency = async (amount, fromCurrency, toCurrency) => {
  try {
    if (fromCurrency === toCurrency) {
      return { amount, currency: toCurrency };
    }

    const response = await axios.post("/currency/convert", {
      amount,
      fromCurrency,
      toCurrency,
    });

    return {
      amount: response.data.convertedAmount,
      currency: toCurrency,
    };
  } catch (error) {
    console.error("Error converting currency:", error);
    return { amount, currency: fromCurrency }; // fallback
  }
};

// Get all currency rates
export const getCurrencyRates = async () => {
  try {
    const response = await axios.get("/currency/rates");
    return response.data.rates || [];
  } catch (error) {
    console.error("Error fetching currency rates:", error);
    return [];
  }
};

// Get specific currency rate
export const getCurrencyRate = async (targetCurrency, baseCurrency = "USD") => {
  try {
    const endpoint =
      baseCurrency === "USD"
        ? `/currency/rate/${targetCurrency}`
        : `/currency/rate/${baseCurrency}/${targetCurrency}`;

    const response = await axios.get(endpoint);
    return response.data.rate;
  } catch (error) {
    console.error("Error fetching currency rate:", error);
    return null;
  }
};

// Convert from display currency back to USD
export const convertToUSD = async (amount, fromCurrency) => {
  try {
    if (fromCurrency === "USD") {
      return { amount, currency: "USD" };
    }

    const response = await axios.post("/currency/convert", {
      amount,
      fromCurrency,
      toCurrency: "USD",
    });

    return {
      amount: response.data.convertedAmount,
      currency: "USD",
    };
  } catch (error) {
    console.error("Error converting to USD:", error);
    return { amount, currency: fromCurrency }; // fallback
  }
};
